import generalMutations from "./generalMutations";
import generalActions from "./generalActions";

export default {
  namespaced: true,
  state: {
    objects: {},
    className: "RoomType",
  },

  mutations: {
    ...generalMutations,
  },
  actions: {
    ...generalActions,
  },
};
